// extracted by mini-css-extract-plugin
var _1 = "ClaimRowStyles-module__buttons___wECrj";
var _2 = "ClaimRowStyles-module__claim-row___pBpEH";
var _3 = "ClaimRowStyles-module__claim-row___pBpEH";
var _4 = "ClaimRowStyles-module__decoration___KDFlA";
var _5 = "ClaimRowStyles-module__dot___vD4h1";
var _6 = "ClaimRowStyles-module__fadeInLeftShortAnimation___cBCQ_";
var _7 = "ClaimRowStyles-module__fadeInLeftShortestAnimation___Mq9FV";
var _8 = "ClaimRowStyles-module__fadeInRightShortAnimation___AJSKW";
var _9 = "ClaimRowStyles-module__fadeInUpAnimation___Os_hh";
var _a = "ClaimRowStyles-module__item____VdIB";
var _b = "ClaimRowStyles-module__item--name___nTtah";
var _c = "ClaimRowStyles-module__item--values___gmhAy";
var _d = "ClaimRowStyles-module__item--name___nTtah";
var _e = "ClaimRowStyles-module__item--values___gmhAy";
var _f = "ClaimRowStyles-module__user-claims___EuUdO";
var _10 = "ClaimRowStyles-module__user-claims___EuUdO";
export { _1 as "buttons", _2 as "claim-row", _3 as "claimRow", _4 as "decoration", _5 as "dot", _6 as "fadeInLeftShortAnimation", _7 as "fadeInLeftShortestAnimation", _8 as "fadeInRightShortAnimation", _9 as "fadeInUpAnimation", _a as "item", _b as "item--name", _c as "item--values", _d as "itemName", _e as "itemValues", _f as "user-claims", _10 as "userClaims" }
